export const assignemntStatusType = {
    pending: 'PENDING',
    accepted: 'ACCEPTED',
    completed:'COMPLETED',
    default: 'DEFAULT'
};